import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('groups' + params)
	},
	loadOptimal() {
		return http.get('groups?optimal=true')
	},
	create(data) {
		return http.post('groups', data)
	},
	update(data) {
		return http.put('groups/' + data.id, data)
	},
	show(id) {
		return http.get('groups/' + id)
	}
}